<template>
	<inertia-head title="Contact Us" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Contact Us</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Here you can contact us for any concerns. Please see details below
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div class="block block-rounded">
			<div class="block-content block-content-full">
				<p class="fw-semibold">
					Call our Truly Rich Club Communications Hub From 8AM to 5PM Philippine
					Standard Time Mondays to Fridays (except holidays) We're currently
					experiencing issues with our lines. Please take note of the temporary
					numbers we have below.
				</p>
				<div class="row">
					<div class="col-md-6">
						<h3 class="content-heading fw-semibold">
							For Globe/TM Subscribers
						</h3>
						<ul>
							<li>+63 917-500-9671</li>
							<li>+63 917-301-7947</li>
							<li>+63 917-301-7838</li>
							<li>+63 917-301-8279</li>
						</ul>
						<h3 class="content-heading fw-semibold">
							For Smart/Sun/ Subscribers
						</h3>
						<ul>
							<li>+63 919-095-2512</li>
							<li>+63 919-095-2530</li>
						</ul>
					</div>
					<div class="col-md-6">
						<h3 class="content-heading fw-semibold">For Landline callers</h3>
						<ul>
							<li>(02)7904-0598</li>
							<li>(02)7904-0554</li>
							<li>(02)7904-0453</li>
						</ul>
						<p class="fw-semibold">
							Or you may email us at
							<a href="mailto:support@trulyrichclub.com"
								>support@trulyrichclub.com</a
							>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: AuthLayout,
	setup() {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
	},
}
</script>
